<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'VEHICLE_LIST',
    }"
  >
    <!-- <Notice v-if="car && car.total_odometer != 0" class="mb-8 col-span-full">
      مسافت کل طی شده وسیله نقلیه
      <b>{{ car.total_odometer / 1000 }}</b> کیلومتر است.
    </Notice> -->
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane
        v-for="tab in types"
        :key="tab.name"
        :lazy="true"
        :label="$t(tab.label)"
        :name="tab.name"
      >
        <component
          :is="tab.name"
          v-if="activeName == tab.name"
          :car="car"
          :loading="loading"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </Content>
</template>
<script>
import Notice from '@/components/elements/notice'
import BasicInfo from '@/components/cars/tabs/BasicInfo'
import CostInfo from '@/components/cars/tabs/CostInfo'
import InsuranceInfo from '@/components/cars/tabs/Insurance'
import TechInfo from '@/components/cars/tabs/TechInfo'

import { isNull } from '@/mixins/isNull'
import { getACar } from '@/api/cars'
import { currency } from '@/mixins/currency'

export default {
  mixins: [isNull, currency],
  data() {
    return {
      car: null,
      loading: true,
      types: [
        {
          name: 'BasicInfo',
          label: 'BASIC_INFO',
        },
        {
          name: 'CostInfo',
          label: 'COST_INFO',
        },
        {
          name: 'InsuranceInfo',
          label: 'INSURANCE_INFO',
        },
        {
          name: 'TechInfo',
          label: 'TECHNICAL_INFO',
        },
      ],
      activeName: 'BasicInfo',
    }
  },
  components: {
    Notice,
    BasicInfo,
    CostInfo,
    InsuranceInfo,
    TechInfo,
  },
  created() {
    getACar.api(this.$route.params.id).then((res) => {
      this.car = {
        ...res,
        carId: this.$route.params.id,
        color: this.isNull(res.color),
        vehicle: this.isNull(res.vehicle),
        ownership: this.isNull(res.ownership),

        driver: this.isNull(res.driver),
        cabin: this.isNull(res.cabin),
        status: this.isNull(res.status),
        device: this.isNull(res.device),
        license_plate_1: res.license_plate.substring(0, 2),
        license_plate_letter: res.license_plate.substring(2, 4),
        license_plate_3: res.license_plate.substring(4, 7),
        license_plate_4: res.license_plate.substring(7, 9),
        company_vehicle_tags: res.company_vehicle_tags.map((i) => i.id),

        disabled: this.$route.name.includes('VIEW') ? true : false,
        odometer_during_add: res.odometer_during_add / 1000,
      }
      this.loading = false
    })
  },
}
</script>
